import React from "react";
import WordScoreBubble from "../../../../../../basic/wordScoreBubble/WordScoreBubble";

import {
    MobileWordCardWrapper,
    MobileWordCardHeader,
    MobileIconButton,
    MobileWordCardDeleteIcon,
} from "./StyledComponents";

interface MobileWordCardProps {
    wordId: string;
    showScores: boolean;
    onDelete: () => void;
    deleteLabel: string;
    children: React.ReactNode;
}

const MobileWordCard: React.FC<MobileWordCardProps> = (props) => {
    return (
        <MobileWordCardWrapper>
            <MobileWordCardHeader>
                {props.showScores ? <WordScoreBubble wordId={props.wordId} /> : <span />}
                <MobileIconButton
                    type="button"
                    aria-label={props.deleteLabel}
                    onClick={props.onDelete}
                >
                    <MobileWordCardDeleteIcon name={"close"} />
                </MobileIconButton>
            </MobileWordCardHeader>
            {props.children}
        </MobileWordCardWrapper>
    );
};

export default MobileWordCard;
